const VALID_TAGS = ['video', 'svg', 'object', 'img', 'input', 'iframe', 'canvas', 'audio'];
const domParser = new DOMParser();
function getParsedBody(text) {
  return domParser.parseFromString(text, 'text/html').body;
}
function isEmpty(rootElement) {
  return !rootElement.innerText.trim();
}
function hasValidTag(rootElement) {
  return VALID_TAGS.some(tag => rootElement.querySelectorAll(tag).length > 0);
}
export function isBodyValid(content) {
  if (!content) {
    return false;
  }
  const rootElement = getParsedBody(content);
  return hasValidTag(rootElement) || !isEmpty(rootElement);
}